import { render, staticRenderFns } from "./HrmineWelcome.vue?vue&type=template&id=3c4bd9ba"
import script from "./HrmineWelcome.vue?vue&type=script&lang=js"
export * from "./HrmineWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports